__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "CscdataApp";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@hero/federation-library", "0.5.2", () => (Promise.all([__webpack_require__.e(917), __webpack_require__.e(416)]).then(() => (() => (__webpack_require__(57917))))));
			register("@hero/hero-auth-app", "1.3.0", () => (Promise.all([__webpack_require__.e(100), __webpack_require__.e(416), __webpack_require__.e(294)]).then(() => (() => (__webpack_require__(28100))))));
			register("@hero/hero-notifications-app", "1.0.0", () => (Promise.all([__webpack_require__.e(402), __webpack_require__.e(416)]).then(() => (() => (__webpack_require__(98402))))));
			register("@mui/material", "5.14.6", () => (Promise.all([__webpack_require__.e(482), __webpack_require__.e(392), __webpack_require__.e(204), __webpack_require__.e(600), __webpack_require__.e(83), __webpack_require__.e(416), __webpack_require__.e(361)]).then(() => (() => (__webpack_require__(53083))))));
			register("@mui/system", "5.14.6", () => (Promise.all([__webpack_require__.e(482), __webpack_require__.e(600), __webpack_require__.e(64), __webpack_require__.e(352), __webpack_require__.e(416), __webpack_require__.e(755)]).then(() => (() => (__webpack_require__(13352))))));
			register("@mui/system", "5.15.15", () => (Promise.all([__webpack_require__.e(482), __webpack_require__.e(64), __webpack_require__.e(592), __webpack_require__.e(416), __webpack_require__.e(642)]).then(() => (() => (__webpack_require__(99592))))));
			register("@nrel-design-system/hero", "0.10.10", () => (Promise.all([__webpack_require__.e(392), __webpack_require__.e(204), __webpack_require__.e(333), __webpack_require__.e(416), __webpack_require__.e(361), __webpack_require__.e(294), __webpack_require__.e(865), __webpack_require__.e(773), __webpack_require__.e(634)]).then(() => (() => (__webpack_require__(24333))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(935), __webpack_require__.e(416)]).then(() => (() => (__webpack_require__(73935))))));
			register("react-router-dom", "6.15.0", () => (Promise.all([__webpack_require__.e(818), __webpack_require__.e(416)]).then(() => (() => (__webpack_require__(49818))))));
			register("react", "18.2.0", () => (__webpack_require__.e(976).then(() => (() => (__webpack_require__(67294))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};